import { render, staticRenderFns } from "./ProductStandard3.vue?vue&type=template&id=4cd7838a&scoped=true"
import script from "./ProductStandard3.vue?vue&type=script&lang=js"
export * from "./ProductStandard3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd7838a",
  null
  
)

export default component.exports